import React, { useEffect, useState } from 'react';

import type { IntlAddress } from '@/typings/api-models';
import stateCodeToName from '@/constants/stateCodeToName';
import { Input } from '../Input';
import Select from '../Select';
import s from '../AddressUS/AddressUS.module.scss';
import Fieldset from '../shared/Fieldset';
import Button from '../../Button';

const countries = [
  { key: 'US', label: 'United States' },
  { key: 'AF', label: 'Afghanistan' },
  { key: 'AL', label: 'Albania' },
  { key: 'DZ', label: 'Algeria' },
  { key: 'AD', label: 'Andorra' },
  { key: 'AO', label: 'Angola' },
  { key: 'AG', label: 'Antigua and Barbuda' },
  { key: 'AR', label: 'Argentina' },
  { key: 'AM', label: 'Armenia' },
  { key: 'AU', label: 'Australia' },
  { key: 'AT', label: 'Austria' },
  { key: 'AZ', label: 'Azerbaijan' },
  { key: 'BS', label: 'Bahamas' },
  { key: 'BH', label: 'Bahrain' },
  { key: 'BD', label: 'Bangladesh' },
  { key: 'BB', label: 'Barbados' },
  { key: 'BY', label: 'Belarus' },
  { key: 'BE', label: 'Belgium' },
  { key: 'BZ', label: 'Belize' },
  { key: 'BJ', label: 'Benin' },
  { key: 'BT', label: 'Bhutan' },
  { key: 'BO', label: 'Bolivia' },
  { key: 'BA', label: 'Bosnia and Herzegovina' },
  { key: 'BW', label: 'Botswana' },
  { key: 'BR', label: 'Brazil' },
  { key: 'BN', label: 'Brunei' },
  { key: 'BG', label: 'Bulgaria' },
  { key: 'BF', label: 'Burkina Faso' },
  { key: 'BI', label: 'Burundi' },
  { key: 'CV', label: 'Cabo Verde' },
  { key: 'KH', label: 'Cambodia' },
  { key: 'CM', label: 'Cameroon' },
  { key: 'CA', label: 'Canada' },
  { key: 'CF', label: 'Central African Republic' },
  { key: 'TD', label: 'Chad' },
  { key: 'CL', label: 'Chile' },
  { key: 'CN', label: 'China' },
  { key: 'CO', label: 'Colombia' },
  { key: 'KM', label: 'Comoros' },
  { key: 'CD', label: 'Congo, Democratic Republic of the' },
  { key: 'CG', label: 'Congo, Republic of the' },
  { key: 'CR', label: 'Costa Rica' },
  { key: 'CI', label: "Côte d'Ivoire" },
  { key: 'HR', label: 'Croatia' },
  { key: 'CU', label: 'Cuba' },
  { key: 'CY', label: 'Cyprus' },
  { key: 'CZ', label: 'Czech Republic' },
  { key: 'DK', label: 'Denmark' },
  { key: 'DJ', label: 'Djibouti' },
  { key: 'DM', label: 'Dominica' },
  { key: 'DO', label: 'Dominican Republic' },
  { key: 'EC', label: 'Ecuador' },
  { key: 'EG', label: 'Egypt' },
  { key: 'SV', label: 'El Salvador' },
  { key: 'GQ', label: 'Equatorial Guinea' },
  { key: 'ER', label: 'Eritrea' },
  { key: 'EE', label: 'Estonia' },
  { key: 'SZ', label: 'Eswatini' },
  { key: 'ET', label: 'Ethiopia' },
  { key: 'FJ', label: 'Fiji' },
  { key: 'FI', label: 'Finland' },
  { key: 'FR', label: 'France' },
  { key: 'GA', label: 'Gabon' },
  { key: 'GM', label: 'Gambia' },
  { key: 'GE', label: 'Georgia' },
  { key: 'DE', label: 'Germany' },
  { key: 'GH', label: 'Ghana' },
  { key: 'GR', label: 'Greece' },
  { key: 'GD', label: 'Grenada' },
  { key: 'GT', label: 'Guatemala' },
  { key: 'GN', label: 'Guinea' },
  { key: 'GW', label: 'Guinea-Bissau' },
  { key: 'GY', label: 'Guyana' },
  { key: 'HT', label: 'Haiti' },
  { key: 'HN', label: 'Honduras' },
  { key: 'HU', label: 'Hungary' },
  { key: 'IS', label: 'Iceland' },
  { key: 'IN', label: 'India' },
  { key: 'ID', label: 'Indonesia' },
  { key: 'IR', label: 'Iran' },
  { key: 'IQ', label: 'Iraq' },
  { key: 'IE', label: 'Ireland' },
  { key: 'IL', label: 'Israel' },
  { key: 'IT', label: 'Italy' },
  { key: 'JM', label: 'Jamaica' },
  { key: 'JP', label: 'Japan' },
  { key: 'JO', label: 'Jordan' },
  { key: 'KZ', label: 'Kazakhstan' },
  { key: 'KE', label: 'Kenya' },
  { key: 'KI', label: 'Kiribati' },
  { key: 'KP', label: 'Korea, North' },
  { key: 'KR', label: 'Korea, South' },
  { key: 'KW', label: 'Kuwait' },
  { key: 'KG', label: 'Kyrgyzstan' },
  { key: 'LA', label: 'Laos' },
  { key: 'LV', label: 'Latvia' },
  { key: 'LB', label: 'Lebanon' },
  { key: 'LS', label: 'Lesotho' },
  { key: 'LR', label: 'Liberia' },
  { key: 'LY', label: 'Libya' },
  { key: 'LI', label: 'Liechtenstein' },
  { key: 'LT', label: 'Lithuania' },
  { key: 'LU', label: 'Luxembourg' },
  { key: 'MG', label: 'Madagascar' },
  { key: 'MW', label: 'Malawi' },
  { key: 'MY', label: 'Malaysia' },
  { key: 'MV', label: 'Maldives' },
  { key: 'ML', label: 'Mali' },
  { key: 'MT', label: 'Malta' },
  { key: 'MH', label: 'Marshall Islands' },
  { key: 'MR', label: 'Mauritania' },
  { key: 'MU', label: 'Mauritius' },
  { key: 'MX', label: 'Mexico' },
  { key: 'FM', label: 'Micronesia' },
  { key: 'MD', label: 'Moldova' },
  { key: 'MC', label: 'Monaco' },
  { key: 'MN', label: 'Mongolia' },
  { key: 'ME', label: 'Montenegro' },
  { key: 'MA', label: 'Morocco' },
  { key: 'MZ', label: 'Mozambique' },
  { key: 'MM', label: 'Myanmar' },
  { key: 'NA', label: 'Namibia' },
  { key: 'NR', label: 'Nauru' },
  { key: 'NP', label: 'Nepal' },
  { key: 'NL', label: 'Netherlands' },
  { key: 'NZ', label: 'New Zealand' },
  { key: 'NI', label: 'Nicaragua' },
  { key: 'NE', label: 'Niger' },
  { key: 'NG', label: 'Nigeria' },
  { key: 'MK', label: 'North Macedonia' },
  { key: 'NO', label: 'Norway' },
  { key: 'OM', label: 'Oman' },
  { key: 'PK', label: 'Pakistan' },
  { key: 'PW', label: 'Palau' },
  { key: 'PA', label: 'Panama' },
  { key: 'PG', label: 'Papua New Guinea' },
  { key: 'PY', label: 'Paraguay' },
  { key: 'PE', label: 'Peru' },
  { key: 'PH', label: 'Philippines' },
  { key: 'PL', label: 'Poland' },
  { key: 'PT', label: 'Portugal' },
  { key: 'QA', label: 'Qatar' },
  { key: 'RO', label: 'Romania' },
  { key: 'RU', label: 'Russia' },
  { key: 'RW', label: 'Rwanda' },
  { key: 'KN', label: 'Saint Kitts and Nevis' },
  { key: 'LC', label: 'Saint Lucia' },
  { key: 'VC', label: 'Saint Vincent and the Grenadines' },
  { key: 'WS', label: 'Samoa' },
  { key: 'SM', label: 'San Marino' },
  { key: 'ST', label: 'Sao Tome and Principe' },
  { key: 'SA', label: 'Saudi Arabia' },
  { key: 'SN', label: 'Senegal' },
  { key: 'RS', label: 'Serbia' },
  { key: 'SC', label: 'Seychelles' },
  { key: 'SL', label: 'Sierra Leone' },
  { key: 'SG', label: 'Singapore' },
  { key: 'SK', label: 'Slovakia' },
  { key: 'SI', label: 'Slovenia' },
  { key: 'SB', label: 'Solomon Islands' },
  { key: 'SO', label: 'Somalia' },
  { key: 'ZA', label: 'South Africa' },
  { key: 'SS', label: 'South Sudan' },
  { key: 'ES', label: 'Spain' },
  { key: 'LK', label: 'Sri Lanka' },
  { key: 'SD', label: 'Sudan' },
  { key: 'SR', label: 'Suriname' },
  { key: 'SE', label: 'Sweden' },
  { key: 'CH', label: 'Switzerland' },
  { key: 'SY', label: 'Syria' },
  { key: 'TW', label: 'Taiwan' },
  { key: 'TJ', label: 'Tajikistan' },
  { key: 'TZ', label: 'Tanzania' },
  { key: 'TH', label: 'Thailand' },
  { key: 'TL', label: 'Timor-Leste' },
  { key: 'TG', label: 'Togo' },
  { key: 'TO', label: 'Tonga' },
  { key: 'TT', label: 'Trinidad and Tobago' },
  { key: 'TN', label: 'Tunisia' },
  { key: 'TR', label: 'Turkey' },
  { key: 'TM', label: 'Turkmenistan' },
  { key: 'TV', label: 'Tuvalu' },
  { key: 'UG', label: 'Uganda' },
  { key: 'UA', label: 'Ukraine' },
  { key: 'AE', label: 'United Arab Emirates' },
  { key: 'GB', label: 'United Kingdom' },
  { key: 'UY', label: 'Uruguay' },
  { key: 'UZ', label: 'Uzbekistan' },
  { key: 'VU', label: 'Vanuatu' },
  { key: 'VA', label: 'Vatican City' },
  { key: 'VE', label: 'Venezuela' },
  { key: 'VN', label: 'Vietnam' },
  { key: 'YE', label: 'Yemen' },
  { key: 'ZM', label: 'Zambia' },
  { key: 'ZW', label: 'Zimbabwe' },
];

export const DEFAULT_VALUE: IntlAddress = {
  city: '',
  country: '',
  line1: '',
  line2: '',
  postCode: '',
};

const AddressIntl: React.FC<
  Pick<Parameters<typeof Fieldset>[0], 'label' | 'description' | 'required'> & {
    value: IntlAddress | null;
    onChange: (address: IntlAddress) => void;
    disabled?: boolean;
    onBlur?: () => void;
    onFocus?: () => void;
  } & {
    error?: string;
  }
> = ({ label, description, required, value, onChange, onBlur, onFocus, disabled, error }) => {
  const [address, setAddress] = useState(value || DEFAULT_VALUE);

  const handleInputChange = (field: string) => (v: string) => {
    const newAddress = { ...address, [field]: v };

    setAddress(newAddress);
    onChange(newAddress);
  };

  useEffect(() => {
    if (value) {
      setAddress(value);
    }
  }, [value]);

  return (
    <Fieldset label={label} description={description} required={required} error={error}>
      <div className={s['address-us']}>
        {address !== DEFAULT_VALUE && (
          <Button variant="secondary" className={s.clear} size="xs" onClick={() => setAddress(DEFAULT_VALUE)}>
            Clear
          </Button>
        )}
        <Input
          label="Street address"
          compact
          value={address.line1}
          onChange={handleInputChange('line1')}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
        />
        <Input
          label="Apartment / Floor / Suite number"
          compact
          value={address.line2}
          onChange={handleInputChange('line2')}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          optional
        />
        {address.country === 'US' && (
          <Select
            label="Country"
            compact
            placeholder="Select"
            options={countries}
            value={address.country}
            onChange={handleInputChange('country')}
            disabled={disabled}
            onFocus={onFocus}
          />
        )}
        <div className={s.row}>
          {address.country !== 'US' && (
            <Select
              label="Country"
              compact
              placeholder="Select"
              options={countries}
              value={address.country}
              onChange={handleInputChange('country')}
              disabled={disabled}
              onFocus={onFocus}
            />
          )}
          <Input
            label="City"
            compact
            value={address.city}
            onChange={handleInputChange('city')}
            disabled={disabled}
            onBlur={onBlur}
            onFocus={onFocus}
          />
          {address.country === 'US' && (
            <Select
              label="State"
              compact
              placeholder="Select"
              options={stateCodeToName}
              value={address.state}
              onChange={handleInputChange('state')}
              disabled={disabled}
              onFocus={onFocus}
            />
          )}
          <Input
            label="Post Code"
            compact
            value={address.postCode}
            onChange={handleInputChange('postCode')}
            onBlur={onBlur}
            disabled={disabled}
            onFocus={onFocus}
          />
        </div>
      </div>
    </Fieldset>
  );
};

export default AddressIntl;
